<script setup lang="ts">
import { computed } from "vue";
import GreetingPage from "./templates/GreetingPage.vue";
import FobbidenErrorSvg from "../components/error-images/FobbidenErrorSvg.vue";
import UnknownErrorSvg from "../components/error-images/UnknownErrorSvg.vue";
import LinkExpiredError from "../components/error-images/LinkExpiredError.vue";
import { cleanup } from "../states/media/state";
import { ws_instance } from "../websocket/ws-instance";

const props = defineProps<{
  errtype: string;
}>();
const errorContent = computed(() => {
  if (props.errtype === "already-connected") {
    return {
      title: "Доступ запрещен",
      text: "Вы уже подключены к этой встрече",
      image: FobbidenErrorSvg,
    };
  } else if(props.errtype === "bad-query") {
    return {
      title: "Неизвестный видеозвонок",
      text: "Ссылка недействительна",
      image: UnknownErrorSvg,
    };
  } else if(props.errtype === "bad-user") {
    return {
      title: "Доступ запрещен",
      text: "Не получилось вас авторизовать",
      image: FobbidenErrorSvg,
    };
  } else if(props.errtype === "call-exist") {
    return {
      title: "Внимание!",
      text: "Вы уже находитесь в другом активном видеозвонке. Одновременно можно участвовать только в одном видеозвонке.",
      image: FobbidenErrorSvg,
    };
  } else if(props.errtype === 'not-found-record') {
    return {
      title: "Неизвестная ссылка",
      text: "Срок хранения записи истек",
      image: UnknownErrorSvg,
    };
  } else if(props.errtype === 'new-auth') {
    return {
      title: "Обнаружена более поздняя авторизация",
      text: "Использование сервиса возможно с одной учетной записи одновременно",
      image: UnknownErrorSvg,
    };
  } else if(props.errtype === 'link-expired') {
    return {
      title: "Внимание!",
      text: "Ссылка на видеозвонок устарела, создайте новую.",
      image: LinkExpiredError,
    };
  } else if(props.errtype === 'not-participant') {
    return {
      title: "Доступ запрещен",
      text: "Вас нет в списке участников видеозвонка",
      image: FobbidenErrorSvg,
    };
  } else if(props.errtype === 'token-expired') {
    return {
      title: "Доступ запрещен",
      text: "Срок действия вашей авторизации истек",
      image: FobbidenErrorSvg,
    };
  }
  return {
    title: "Неизвестная ошибка",
    text: "При работе возникла непредвиденная ошибка. Попробуйте повторить ещё раз.",
    image: UnknownErrorSvg,
  };
});
ws_instance.disconnect()
cleanup()
</script>
<template>
  <GreetingPage class="error-view">
    <div class="content">
      <component :is="errorContent.image" />
      <div class="text-content">
        <div class="title">{{ errorContent.title }}</div>
        <div class="text">{{ errorContent.text }}</div>
      </div>
    </div>
  </GreetingPage>
</template>
<style scoped>
.content {
  display: flex;
  gap: 40px;
}

.text-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
}

.title {
  color: #d51f26;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.text {
  color: #292929;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: 500px;
}
</style>
